export function PrivacyPolicyPage() {
    return (
        <div className="min-h-screen pt-40 pb-24">
            <div className="max-w-3xl mx-auto px-6">
                <div className="mb-16">
                    <p className="uppercase tracking-[0.3em] text-sm text-stone-400 mb-4 font-light">Legal</p>
                    <h1 className="font-serif text-5xl md:text-7xl font-light italic">Privacy Policy</h1>
                </div>
                <div className="space-y-10 text-sm text-stone-600 font-light leading-relaxed">
                    <div>
                        <h2 className="font-serif text-xl font-light italic text-stone-900 mb-3">What we collect</h2>
                        <p>We collect information you provide when placing an order or subscribing to our newsletter — including your name, email address, shipping address, and payment details. Payment data is processed securely through our payment provider and never stored on our servers.</p>
                    </div>
                    <div>
                        <h2 className="font-serif text-xl font-light italic text-stone-900 mb-3">How we use it</h2>
                        <p>Your information is used solely to fulfil your orders, communicate about them, and — if you've opted in — send occasional updates about new products and offers. We do not sell, rent, or share your personal data with third parties for marketing purposes.</p>
                    </div>
                    <div>
                        <h2 className="font-serif text-xl font-light italic text-stone-900 mb-3">Cookies</h2>
                        <p>We use essential cookies to keep your cart intact and measure site performance. No third-party advertising cookies are used.</p>
                    </div>
                    <div>
                        <h2 className="font-serif text-xl font-light italic text-stone-900 mb-3">Your rights</h2>
                        <p>You have the right to access, correct, or delete the personal data we hold about you at any time. To make a request, email <span className="text-stone-900">privacy@beetrele.com</span>.</p>
                    </div>
                    <p className="text-xs text-stone-400 pt-4 border-t border-stone-100">Last updated: March 2026</p>
                </div>
            </div>
        </div>
    );
}
